import apiV2 from "api-v2";
import { downloadFileNoPopup } from "helpers/linkHelper";
import { ApiResponse } from "types/common.types";
import { logErrorIfDebug } from "utils/logging";

type PdfDownloadPayload = {
	download_url: string;
	filename: string;
};

export const generatePdf = async (
	type: "summary" | "responses",
	rfxId: number,
	respondentId: number,
	isGuest: boolean
) => {
	try {
		let route;
		if (respondentId) {
			route = isGuest
				? `guest/${rfxId}/download-response/${respondentId}`
				: `rfq/${rfxId}/download-response/${respondentId}`;
		} else {
			route =
				type === "summary"
					? `rfq/${rfxId}/download-summary`
					: `rfq/${rfxId}/download-all-responses`;
		}
		await apiV2
			.get<ApiResponse<PdfDownloadPayload>>(route, {
				timeout: 300000, // 5 minutes for this request only
			})
			.then((response) => {
				const url = response.data.data.download_url;
				downloadFileNoPopup(url);
			})
			.catch((ex) => {
				logErrorIfDebug(ex?.message);
			});
	} catch (error) {
		logErrorIfDebug("PDF Download error", error);
	}
};
